
    <sc-alert-messages *ngIf="showAlerts"></sc-alert-messages>
    <router-outlet></router-outlet>
  